import ClipboardItem from './ClipboardItem';
import TextItem from './TextItem';
import ImageItem from './ImageItem';
import Session from './Session';

// Factory method to create appropriate item type
export const createItem = (rawItem, status = ClipboardItem.STATUS_PERSISTED) => {
  const { id, content_type, content_url, created_at } = rawItem;

  // Create appropriate model class based on content type
  switch (content_type) {
    case 'text/plain':
      return new TextItem(rawItem, status);
    case 'image/png':
    case 'image/jpeg':
    case 'image/gif':
    case 'image/webp':
    case 'image/svg+xml':
    case 'image/tiff':
    case 'image/bmp':
      return new ImageItem(rawItem, status);
    default:
      // Fallback to base ClipboardItem for unknown types
      console.warn(`Unknown content type: ${content_type}, using base ClipboardItem`);
      return new ClipboardItem(id, status, content_type, content_url, created_at);
  }
};

// Factory function to create sessions
export const createSession = (rawSession, currentSessionId = null) => {
  return Session.create(rawSession, currentSessionId);
};

// Batch create sessions
export const createSessions = (rawSessions, currentSessionId = null) => {
  return Session.createMany(rawSessions, currentSessionId);
};

export { ClipboardItem, TextItem, ImageItem, Session };
